/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { createResize } from '../../factoriesAny.js';
export var resizeDependencies = {
  matrixDependencies,
  createResize
};